// TODO (webpack v5): drop the `build/package/` part of these import paths.
// Snabbdom>=1 uses the package.json#exports field that webpack v4 doesn't know
// about
//
// https://github.com/webpack/webpack/issues/9509
// https://webpack.js.org/guides/package-exports/
import {toVNode} from 'snabbdom/build/package/tovnode';
import {sign} from 'snabbdom-signature';

/**
 * Creates an element for the virtual DOM from an existing DOM node
 * @method createElementFromNode
 * @param {Node} node DOM node to convert
 * @returns {VNode} The vnode to use in the virtual DOM
 */
export default function createElementFromNode(node) {
	const vnode = sign(toVNode(node));
	fixNamespace(vnode); // fixes issue with missing namespace for svgs: https://github.com/snabbdom/snabbdom/issues/388
	return vnode;
}

const fixNamespace = (vnode, xmlns = vnode.data && vnode.data.attrs && vnode.data.attrs.xmlns) => {
	const {children, data} = vnode;

	if (data && !data.ns && xmlns) data.ns = xmlns;

	if (children) {
		const {length: childrenCount} = children;
		for (let i = 0; i < childrenCount; i++) fixNamespace(children[i], xmlns);
	}
};
